import {
    ViewFactory,
    ComponentManager,
} from 'radpresentation.htmlclient.defaultviewextensions';
import ConnectPropertyGroupViewViewModel from '@/ViewModels/Views/ConnectPropertyGroupViewViewModel';
import ConnectPropertyGroupView from '@/Views/ConnectPropertyGroupView';
class ConnectPropertyGroupViewFactory extends ViewFactory {
    public viewModel: ConnectPropertyGroupViewViewModel;
    public view: ConnectPropertyGroupView;

    constructor(private params: any) {
        super(params);
    }

    public getRegion(): string {
        return 'Modal';
    }

    public getView(): JQuery<HTMLElement> {
        if (!this.viewModel) {
            this.viewModel = new ConnectPropertyGroupViewViewModel({
                callback: this.params.callback,
                locator: this.params.locator,
                viewFactory: this,
            });
        }

        if (!this.view) {
            this.view = new ConnectPropertyGroupView(
                this.viewModel,
                this.createRootElement('ConnectPropertyGroupView')
            );
        }

        return this.view.getTuple().view;
    }
}

export default ConnectPropertyGroupViewFactory;
ComponentManager.setFactory(
    'ConnectPropertyGroup',
    ConnectPropertyGroupViewFactory,
    'RADExtensionManagerHTMLViewExtension'
);
